var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"pt-3"},[_vm._v("Fetching Data for the "+_vm._s(_vm.zipcode)+" ZipCode")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ripple",staticStyle:{"width":"100%","height":"100%"}},[_c('div'),_c('div')])
}]

export { render, staticRenderFns }